import styled, { css } from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

import { TCardVariant } from './Card.types';

export const StyledCard = styled.div.withConfig({ shouldForwardProp })<{ $variant: TCardVariant }>`
  display: flex;
  flex-direction: column;

  ${({ $variant, theme }) =>
    $variant === 'tertiary'
      ? css`
          gap: ${theme.spacing.s}px;
          padding: ${theme.spacing.sm}px;
          background-color: ${theme.colors.backgroundTertiary};
          border: 1px solid ${theme.colors.border};
          border-radius: ${theme.borderRadius.s}px;
        `
      : css`
          gap: ${theme.spacing.m}px;
          padding: ${theme.spacing.m}px;
          background-color: ${theme.colors.backgroundSecondary};
          border: 1px solid ${theme.colors.borderSubtle};
          border-radius: ${theme.borderRadius.l}px;
        `}
`;
